import { useState } from "react";
import { Card, Col, CardTitle, Row } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { CategoryResponse } from "../../../models/ClientportalDashboardModels/GetResponseCategoreis";
import "./Dashboard.scss";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { RoutesEnum } from "../../../utils/RoutesUtil";

interface DashboardCategoryFCProps {
  categories: Array<CategoryResponse>;
  clientId: string | undefined;
  clientProductId: string | undefined;
}
const DashboardCategoryFC = (props: DashboardCategoryFCProps) => {
  const [redirect, setRedirect] = useState<boolean>(false);
  const [quecategoryId, setQueCategoryId] = useState<any>();
  const { screenType } = useParams();
  const location = useLocation();
  const categoryHandler = (id: string) => {
    setQueCategoryId(id);
    setRedirect(true);
  };
  return (
    <>
      {redirect && <Navigate to={`/${RoutesEnum.CLIENT_QUESTIONARIE}/subCategories/${screenType}/${quecategoryId}/${props?.clientProductId}`} state={{...location?.state,clientId: props?.clientId}} />}
      <Row className="CatContentWrapper">
        {props.categories.map((category: CategoryResponse, index: number) => {
          return (
            <Col key={index} sm="6">
              <div
                onClick={() => categoryHandler(category.questionarieCategoryId)}
              >
                <Card className="mainCategoryCard">
                  <CardTitle tag="h5">{category.name}</CardTitle>
                  <div
                    style={{ width: 60, height: 60 }}
                    className="percentageDiv"
                  >
                    <CircularProgressbar
                      value={category.parentCategoeryCompletedPercentage}
                      text={`${category.parentCategoeryCompletedPercentage}%`}
                      strokeWidth={10}
                      styles={buildStyles({
                        // Rotation of path and trail, in number of turns (0-1)
                        // rotation: 0.25,

                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                        strokeLinecap: "butt",

                        // Text size
                        textSize: "24px",

                        // How long animation takes to go from one percentage to another, in seconds
                        pathTransitionDuration: 2.0,

                        // Can specify path transition in more detail, or remove it entirely
                        // pathTransition: 'none',

                        // Colors
                        pathColor: `rgba(0,0,0,0.2, ${category.parentCategoeryCompletedPercentage / 100})`,
                        textColor: "#0C2240",
                        trailColor: "#d6d6d6",
                        backgroundColor: "red",
                      })}
                    />
                  </div>
                  <p className="categoryDescription">{category.description}</p>
                </Card>
              </div>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default DashboardCategoryFC;
